<mat-card appearance="outlined" class="event-card-mobile" [ngClass]="{'disabled': isCardFadedOut, 'with-badges': hasBadges}"
          (click)="eventService.displaySaleActions(event) || eventService.displayRefundActions(event) ? openPurchaseView.emit(event) : null">
  <div class="event-card-image image-blur" [ngStyle]="{'background-image': image}">
    <app-s3-downloader *ngIf="event.boEvent && event.image" [model]="event.image"
                       [type]="S3UploaderTypes.Event" [ratio]="S3UploaderRatios.Square"
                       [ownerCentreId]="event.externalOwnerCentreId" [ownerId]="event.eventId" [noBorder]="true"></app-s3-downloader>
  </div>
  <div class="self-service-icon" *ngIf="event.boEvent">
    <mat-icon class="svg-icon" [svgIcon]="'salespoints_outlined'"></mat-icon>
  </div>
  <div class="event-badges flex decreased-margin">
    <div class="badge event-badge" *ngIf="isPresaleEnded">{{ 'general.api_sales_pre_sale_ended' | translate }}</div>
    <div class="badge event-badge accent" *ngIf="isSaleStartsOn">
      {{ 'general.api_sales_sale_start_on' | translate}} {{ event.sale.start | moment: { withTime: true } }}
    </div>
    <div class="badge event-badge warning" *ngIf="needsWarningBadge">
      {{ warningBadgeText | translate }}
    </div>
  </div>
  <mat-card-content>
    <div class="title two-line-overflow">{{event.title}}</div>
    <div class="venue overflow-ellipsis text-grey">
      <span *ngIf="event.venueTitle?.length">{{event.venueTitle}}<ng-container *ngIf="event.onlineLocation?.length">,&nbsp;</ng-container></span>
      <span *ngIf="event.onlineLocation?.length">{{event.onlineLocation}}</span>
    </div>
    <div class="date text-secondary top-spacer-half flex flex-wrap decreased-margin">
      <ng-container *ngIf="!isPeriodSameDay">
        <span>{{ event.event.start | moment: { tz: event.timezone } }}</span>
        <span>{{ event.event.start | moment: { format: viewService.conf.timeFormat, tz: event.timezone } }}</span>
        <ng-container *ngIf="event.event?.end">
          <span>-</span>
          <span>{{ event.event.end | moment: { tz: event.timezone } }}</span>
          <span>{{ event.event.end | moment: { format: viewService.conf.timeFormat, tz: event.timezone } }}</span>
        </ng-container>
      </ng-container>
      <div class="flex decreased-margin" *ngIf="isPeriodSameDay">
        <span>{{ event.event.start | moment: { tz: event.timezone } }}</span>
        <span>{{ event.event.start | moment: { format: viewService.conf.timeFormat, tz: event.timezone } }} -
          {{ event.event.end | moment: { format: viewService.conf.timeFormat, tz: event.timezone } }}</span>
      </div>
    </div>
  </mat-card-content>
  <mat-card-actions>
    <button mat-button class="icon-button input-button" *ngIf="eventService.displaySaleActions(event)"
            (click)="$event.stopPropagation(); openPurchaseView.emit(event)" [disabled]="eventService.isPurchaseViewDisabled(event, cartService.cartDraftEvent)">
      <mat-icon class="svg-icon" [svgIcon]="'cart'"></mat-icon>
    </button>
    <button mat-button class="icon-button input-button" *ngIf="eventService.displayRefundActions(event)"
            (click)="$event.stopPropagation(); openPurchaseView.emit(event)" [disabled]="eventService.isPurchaseViewDisabled(event, cartService.cartDraftEvent)">
      <mat-icon class="svg-icon" [svgIcon]="'cart'"></mat-icon>
    </button>
    <button mat-button class="icon-button input-button" (click)="$event.stopPropagation(); openEventDetails.emit(event)">
      <mat-icon class="svg-icon" [svgIcon]="'info'"></mat-icon>
    </button>
    <button mat-button class="icon-button input-button" *ngIf="!event.boEvent && authService.hasBookingViewPrivilege"
            (click)="$event.stopPropagation(); openEventBookings.emit(event)">
      <mat-icon class="svg-icon" [svgIcon]="'bookings'"></mat-icon>
    </button>
  </mat-card-actions>
</mat-card>
